// @flow
import { AnyAction } from 'redux';
import { safeCombineReducers } from 'metaup/redux/reduxUtils';
import { offlineTokensListReducer } from './OfflineTokensListPage';
import { offlineTokenCreateReducer } from './OfflineTokenCreatePage';
import { offlineBranchesReducer } from './OfflineBranchesPage';
import { offlineCutsReducer } from './OfflineCutsPage';

export const namespace = 'offlineTokens';

export const reducer = safeCombineReducers(
  {
    list: offlineTokensListReducer,
    create: offlineTokenCreateReducer,
    branches: offlineBranchesReducer,
    cuts: offlineCutsReducer,
  }
);
